<template>
    <div class="earn-item">
        <div class="earn-info">
            <div class="earn-row">
                <div class="earn-date">{{item.timestamp | datetime_history_format}}</div>
            </div>
            <div class="earn-row">
                <div class="earn-description">
                    <div class="earn-title">{{getEarnTitle()}}</div>
                    <div class="earn-desc" v-if="!isNotShowDesc">{{getEarnDesc()}}</div>
                    <div class="earn-remark" v-if="textDesc">{{textDesc}}</div>
                </div>
                <div class="earn-point">
                    <div class="earn-point-lbl">{{item.points | number_format}}</div>
                    <div class="earn-point-ic">
                        <img src="../../../assets/icon/reward_icon_coin@3x.png" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'EarnItem',
    props: {
        lbl: Object,
        item: Object,
        productMaster: Array,
    },
    data: function(){
        return {
            productSKU: '',
            isNotShowDesc: false,
            textDesc: '',
        }
    },
    created: function(){
    },
    methods: {
        getEarnTitle: function () {
            if(!this.item) return;

            var title = "";

            if(this.item.type == 'trace'){
                if(this.item.message){
                    //console.log("item", this.item.message);

                    this.item.message.filter(k => {
                        //console.log('id', k.id, k.Id)
                        let messageId = this.getMessageId(k);
                        // console.log('messageId', messageId, k)
                        if(messageId){                        
                            //#region check only id specify
                            if (messageId == 'BiodermaCouponPoints_BirthMonth' || messageId == 'BiodermaRegister') { 
                                this.textDesc = k.UserDescription;
                            } 
                            else if (messageId == 'Bioderma_CheckIn1day') { 
                                this.textDesc = k.name;
                                this.isNotShowDesc = true;
                            } 
                            else if(messageId.indexOf("BiodermaCoupon") >= 0 || messageId == 'BiodermaUpdateProfile' || messageId == 'BiodermaInvitor') {
                                if(k.CustomInfo){
                                    var customText  = JSON.parse(k.CustomInfo);
                                    title = customText.history_text;
                                }
                                if(messageId == 'BiodermaUpdateProfile' || messageId == 'BiodermaInvitor'){
                                    // this.isNotShowDesc = true;
                                    this.textDesc = k.UserDescription;
                                }
                                if (messageId.includes("BiodermaCouponX2")) {
                                    this.textDesc = k.UserDescription;
                                }
                                
                            }else if(messageId == 'ApproveSurvey' || messageId == 'BiodermaApproveSurvey'){
                                title = this.item.input.Name;
                                this.isNotShowDesc = true;

                            }else if(messageId == 'Ads' || messageId == 'BiodermaAds'){
                                title = this.item.input.CampaignName;
                                this.isNotShowDesc = true;
                            }else{
                                //BiodermaRegister, BiodermaFirstRegister, BiodermaCouponPoints
                                title = k.UserDescription;
                                if(messageId == 'BiodermaRegister' || messageId == 'BiodermaFirstRegister'){
                                    this.isNotShowDesc = true;
                                }
                            }
                        }
                            //#endregion check only id specify
                    })[0];
                }

            }else if(this.item.type == 'migrate'){
                title = this.lbl.history.text_migrate_earn;
            }else{
                title = this.item.message;
            }

            return title;
        },
        getMessageId: function(msg){
            let id1 = msg.id;
            let id2 = msg.Id;
            let id3 = msg.ID;

            if (id1 != null) {
                return id1;
            } else if (id2 != null) {
                return id2;
            } else if (id3 != null) {
                return id3;
            } else {
                return null;
            }
        },
        getEarnDesc: function () { 
            if(!this.item.input) return;

            this.productSKU = this.item.input.Name;

            var description = ''; 
            description = this.productMaster.filter(k => k.skucode == this.productSKU)[0];

            if(description) return description.text;
        },

    }
}
</script>
<style lang="scss" scoped>
@import '@/style/base/base.scss';
@import '@/style/base/baseDisplay.scss';
@import '@/style/base/baseText.scss';
@import './HistoryItem.scss';
</style>
